export default "__VITE_ASSET__Bwcs3uNl__"